import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=73a9d714&scoped=true&"
import script from "./ErrorPage.vue?vue&type=script&lang=js&"
export * from "./ErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=73a9d714&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9d714",
  null
  
)

export default component.exports